// External dependencies
import React from "react";
import classnames from 'classnames';
import { Container } from "reactstrap";
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { RichText, PlainText } from "@wordpress/block-editor";
import { ReactComponent as ArrowIconRight } from "../../assets/arrow-right.svg";
import styles from './ThinkWeMadeAMistake.module.scss';

// Block attributes (custom props)
const attributes = {
  headline: {
    type: "string",
    default: "Think we've made a mistake?",
  },
  description: {
    type: "string",
    default:
      "If you think we've made a mistake about being unable to provide you with free legal advice, let us know.",
  },
  linkText: {
    type: "string",
    default:
      "Submit a request",
  },
};

export const ThinkWeMadeAMistake = ({ headline, description, linkText }) => {
  return (
    <Container className={classnames(styles.wrapper, "my-4 py-3")}>
      <h3 className="mb-3">{headline}</h3>
      {typeof description === "string" ? (
        <div
          className="mb-4"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      ) : (
        description
      )}

      {typeof linkText !== "string" ? (
        <div
          className={styles.linkText}
        >
          {linkText}
          <span className={styles.linkArrow}>
            <ArrowIconRight width={16} stroke="#000" />
          </span>
        </div>
      ) : (
        <a
          className={styles.link}
          onClick={() => window.toggleGatewayForm("ineligible-step-two")}
        >
          <span>{linkText}</span>
          <span className={styles.linkArrow}>
            <ArrowIconRight width={16} stroke="#000" />
          </span>
        </a>
      )}
    </Container>
  );
};

// Edit function (responsible for wp-admin post edit screen)
const edit = ({ setAttributes, attributes }) => {
  const { headline, description, linkText } = attributes;
  return (
    <Fragment>
      <ThinkWeMadeAMistake
        headline={
          <RichText
            value={headline}
            multiline={false}
            onChange={(headline) => setAttributes({ headline })}
            placeholder={__("Headline", "hero")}
            allowedFormats={[]}
            keepPlaceholderOnFocus={true}
          />
        }
        description={
          <RichText
            value={description}
            multiline={true}
            onChange={(description) => setAttributes({ description })}
            placeholder={__("Description", "hero")}
            // allowedFormats={[]}
            keepPlaceholderOnFocus={true}
          />
        }
        linkText={
          <PlainText
            value={linkText}
            multiline={true}
            onChange={(linkText) => setAttributes({ linkText })}
            placeholder={__("Link Text", "hero")}
            keepPlaceholderOnFocus={true}
          />
        }
      />
    </Fragment>
  );
};

// Edit function (responsible for wp-admin post edit screen)
const save = ({ setAttributes, attributes }) => {
  const { headline, description, linkText } = attributes;
  return (
    <div data-mt-attributes={encodeURIComponent(JSON.stringify({ headline, description, linkText }))}>
      <ThinkWeMadeAMistake
        headline={headline}
        description={description}
        linkText={linkText}
      />
    </div>
  );
};

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType("mt/gutenberg-form-think-we-made-a-mistake", {
  /**
   * This is the display title for your block, which can be translated with `i18n` functions.
   * The block inserter will show this name.
   */
  title: __(
    "Think we made a mistake",
    "gutenberg-form-think-we-made-a-mistake"
  ),

  /**
   * An icon property should be specified to make it easier to identify a block.
   * These can be any of WordPress’ Dashicons, or a custom svg element.
   */
  icon: "align-wide",

  /**
   * Blocks are grouped into categories to help users browse and discover them.
   * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
   */
  category: "widgets",

  /**
   * Optional block extended support features.
   */
  // supports: {
  //     // Removes support for an HTML mode.
  //     html: false
  // },
  attributes,

  /**
   * The edit function describes the structure of your block in the context of the editor.
   * This represents what the editor will render when the block is used.
   *
   * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
   *
   * @param {Object} [props] Properties passed from the editor.
   *
   * @return {WPElement} Element to render.
   */
  edit,

  /**
   * The save function defines the way in which the different attributes should be combined
   * into the final markup, which is then serialized by the block editor into `post_content`.
   *
   * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
   *
   * @return {WPElement} Element to render.
   */
  save,
});

export default ThinkWeMadeAMistake;
